import { anatomy } from "@zag-js/slider";
import { sva } from "@agapi/ui/panda/css";
export const rangeSliderStyles = sva({
    slots: anatomy.keys(),
    base: {
        root: {
            position: "relative",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "2",
        },
        label: {
            textStyle: "label",
        },
        valueText: {
            textStyle: "body",
            fontSize: 'sm',
        },
        control: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "20px",
            touchAction: "none",
        },
        track: {
            position: "relative",
            flexGrow: 1,
            height: "items.xs",
            backgroundColor: "borders.subdued",
            boxShadow: '1',
            borderRadius: "full",
            overflow: "hidden",
        },
        range: {
            position: "absolute",
            height: "100%",
            backgroundColor: "surface.primary.vibrant.background",
        },
        thumb: {
            position: "absolute",
            width: "27px",
            height: "27px",
            backgroundColor: "surface.primary.tonal.background",
            borderRadius: "full",
            boxShadow: "2",
            cursor: "pointer",
            zIndex: 1,
            _hover: {
                boxShadow: "md",
            },
            _active: {
                transform: "scale(1.1)",
            },
        },
    },
});
export const classes = rangeSliderStyles();
